import React from "react";
var __jsx = React.createElement;
import assetsStotyblokService from "@lib/storyblok/services/assets-service";
import ImageRender from "@modules/layout/components/shared/image-render";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import useCssModules from "@lib/hooks/use-css-modules";
function PaymentMethodsSection() {
  var _cssModules$footers$f;
  const t = useTranslations("Shared.Layout");
  const {
    0: visaLogo,
    1: setVisaLogo
  } = useState("");
  const {
    0: amexLogo,
    1: setAmexLogo
  } = useState("");
  const {
    0: benefitLogo,
    1: setBenefitLogo
  } = useState("");
  const {
    cssModules
  } = useCssModules();
  const {
    borderColorClassNames,
    paymentMethodsTitleClassNames,
    paymentMethodsContainerClassNames,
    paymentMethodsImagesContainerClassNames,
    paymentMethodsImageVisaClassNames,
    paymentMethodsImageAmericanExpressClassNames,
    paymentMethodsImageBenefitClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerInterbank) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  useEffect(() => {
    const fetchData = async () => {
      try {
        const visaAsset = await assetsStotyblokService.getCreditCardBrandLogo('VISA');
        const amexAsset = await assetsStotyblokService.getCreditCardBrandLogo('AMERICAN_EXPRESS');
        const benefitAsset = await assetsStotyblokService.getBenefitLogo();
        visaAsset ? setVisaLogo(visaAsset) : null;
        amexAsset ? setAmexLogo(amexAsset) : null;
        benefitAsset ? setBenefitLogo(benefitAsset) : null;
      } catch (error) {
        console.error("Error fetching icons", error);
      }
    };
    fetchData();
  }, []);
  return __jsx(React.Fragment, null, __jsx("div", {
    className: "mt-8"
  }, __jsx("div", {
    className: "bg-[#B4B4B4] h-[0.5px] w-full flex-shrink-0 self-stretch"
  })), __jsx("div", {
    className: paymentMethodsContainerClassNames
  }, __jsx("div", {
    className: paymentMethodsTitleClassNames
  }, t("PAYMENT_METHODS")), __jsx("div", {
    className: paymentMethodsImagesContainerClassNames
  }, __jsx(ImageRender, {
    src: visaLogo,
    alt: "visa",
    useImage: false,
    className: paymentMethodsImageVisaClassNames
  }), __jsx(ImageRender, {
    src: amexLogo,
    alt: "American Express",
    useImage: false,
    className: paymentMethodsImageAmericanExpressClassNames
  }), __jsx(ImageRender, {
    src: benefitLogo,
    alt: "benefit",
    useImage: false,
    className: paymentMethodsImageBenefitClassNames
  }))));
}
export default PaymentMethodsSection;